import { esusApi } from "../api";

type Params = {
	uf: string;
	ibgeCode: string;
	cnes: string;
};

export async function getMicroAreas({ uf, ibgeCode, ...params }: Params) {
	const response = await esusApi.get<string[]>(
		`/uf/${uf}/city/${ibgeCode}/Citizen/GetMicroAreas`,
		params
	);
	return response.data || [];
}
